import {
  GET_NOTESASSOCIATES,
  CREATE_NOTESASSOCIATES,
  DELETE_NOTESASSOCIATES,
  UPDATE_NOTESASSOCIATES,
  API_RESPONSE_SUCCESS,
  API_RESPONSE_ERROR,
} from "./actionType";

// common success
export const NotesAssociatesApiResponseSuccess = (actionType, data) => ({
  type: API_RESPONSE_SUCCESS,
  payload: { actionType, data },
});

// common error
export const NotesAssociatesApiResponseError = (actionType, error) => ({
  type: API_RESPONSE_ERROR,
  payload: { actionType, error },
});

export const NotesAssociates = (id) => ({
  type: GET_NOTESASSOCIATES,
  payload: id,
});

export const CreateNotesAssociates = (id, idNote, note) => ({
  type: CREATE_NOTESASSOCIATES,
  payload: { id, idNote, note },
});

export const UpdateNotesAssociates = (id, data) => ({
  type: UPDATE_NOTESASSOCIATES,
  payload: { id, data },
});

export const DeleteNotesAssociates = (id) => ({
  type: DELETE_NOTESASSOCIATES,
  payload: { id },
});
